import { IMeal, IProduct } from "../types/types";

export const mergeMealsToProducts: (meals: IMeal[]) => { products: IProduct[]; localProducts: IProduct[] } = (meals) => {
  const map = new Map<string, IProduct>();
  const localMap = new Map<string, IProduct>();

  for (const meal of meals) {
    const mealQty = meal.quantity ?? 1;
    for (const ing of meal.ingredients) {
      const ingQty = ing.quantity ?? 1;
      const totalQty = mealQty * ingQty;

      const existing = ing.productId && map.get(ing.productId);
      if (existing) {
        existing.quantity = (existing.quantity ?? 0) + totalQty;
      } else {
        ing.productId && map.set(ing.productId, { ...ing, quantity: totalQty });
      }
      if (!ing.productId) {
        const existing = ing.name && localMap.get(ing.name);
        if (existing) {
          existing.quantity = (existing.quantity ?? 0) + totalQty;
        } else {
          localMap.set(ing.name, { ...ing, quantity: totalQty });
        }
      }
    }
  }

  return {
    products: Array.from(map.values()).map((product) =>
      ({ ...product, displayQuantity: product.quantity, quantity: Math.ceil(product.quantity) })
    ),
    localProducts: Array.from(localMap.values()).map((product) =>
      ({ ...product, displayQuantity: product.quantity, quantity: Math.ceil(product.quantity) })
    )
  }
}
